export default __webpack_public_path__ + "4be18c686c9d68b491ae1048799ab383.png";